import { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Col, Drawer, Form, Input, Modal, Row, Space, Spin, message } from "antd";
import { callCreateCategory } from "../../../../config/api";
import { createCategory } from "../../../../types/backend";
import TextFormat from "../../../../components/TextFormat";

const AddCategory = (props: any): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm();
  const showModal = () => {
    setOpen(true);
  };

  const onFinish = async (values: createCategory) => {
    setLoading(true)
    const result = await callCreateCategory(values);
    if (result.statusCode === 201) {
      setOpen(false);
      props.handleFetchCategory();
      message.success("create category success !");
    } else {
      message.error("create category failed !");
    }
    setLoading(false)
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <Spin spinning={loading}>
      <Button type="primary" onClick={showModal} icon={<PlusOutlined />}>
        Thêm mới
      </Button>
      <Modal
        title="Thêm danh mục"
        open={open}
        onOk={() => {
          form.submit();
        }}
        okText="Tạo mới"
        cancelText="Hủy"
        maskClosable={false}
        width={840}
        onCancel={onClose}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: "Please enter Name" }]}>
                <Input placeholder="Please enter title" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="image"
                label="Image"
                rules={[{ required: true, message: "Please enter Image" }]}>
                <Input placeholder="Please enter Image" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              <TextFormat />
            </Col>
          </Row>
        </Form>
      </Modal>
    </Spin>
  );
};

export default AddCategory;
